var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.05025 1.63615C2.65972 1.24563 2.02656 1.24563 1.63603 1.63615C1.24551 2.02668 1.24551 2.65984 1.63603 3.05037L6.58579 8.00012L1.63605 12.9499C1.24552 13.3404 1.24552 13.9736 1.63605 14.3641C2.02657 14.7546 2.65973 14.7546 3.05026 14.3641L8 9.41434L12.9497 14.3641C13.3403 14.7546 13.9734 14.7546 14.364 14.3641C14.7545 13.9736 14.7545 13.3404 14.364 12.9499L9.41421 8.00012L14.364 3.05037C14.7545 2.65984 14.7545 2.02668 14.364 1.63615C13.9734 1.24563 13.3403 1.24563 12.9498 1.63615L8 6.58591L3.05025 1.63615Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseWhite);
export default __webpack_public_path__ + "static/media/IconCloseWhite.1ea59646.svg";
export { ForwardRef as ReactComponent };